import React from "react";

const BranchesSection = () => {

  const serviceLocations = [
    "Delhi NCR – Football & Cricket Turf Construction",
    "Uttar Pradesh – Noida, Ghaziabad, Lucknow, Kanpur",
    "Haryana – Gurugram, Faridabad, Sonipat",
    "Rajasthan – Jaipur, Udaipur, Kota",
    "Punjab – Ludhiana, Chandigarh, Amritsar",
    "Madhya Pradesh – Bhopal, Indore",
  ];

  return (
    <section className="bg-white py-16 px-6">
      <div className="container mx-auto text-center">

        <h2 className="text-3xl sm:text-4xl font-bold mb-8">
          <span className="bg-gradient-to-r from-green-600 via-emerald-500 to-lime-400 bg-clip-text text-transparent">
            Service Locations Across India
          </span>
        </h2>

        <p className="text-gray-600 max-w-2xl mx-auto mb-10">
          ZajraGreen provides premium sports turf installation and maintenance services 
          across multiple cities in India with unmatched quality and expertise.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {serviceLocations.map((location, index) => (
            <div
              key={index}
              className="bg-white border border-emerald-200 shadow-md rounded-2xl p-6 hover:shadow-xl transition-all duration-300"
            >
              <p className="text-black font-medium text-lg">{location}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default BranchesSection;
